import React, { useState } from "react";
import { Link } from 'react-router-dom';

const ProductCard = ({ product }) => {
  // Use default values if necessary
  const price = product.price ?? 0;
  // If product.tags is a comma-delimited string, we use the first tag for display.
  const tag = product.tags ? product.tags.split(",")[0].trim() : null;
  // Manage the image source so that it swaps on hover.
  const [currentSrc, setCurrentSrc] = useState(product.images.light);

  return (
    <Link
    to={`/product/${product.id}`}
    state={{ product }} 
  >
     <div className="group relative transition-transform duration-200 ease-in-out hover:scale-[1.02]">
      <div className="w-[270px] h-[340px] overflow-hidden relative">
        <img
          className="w-full h-full object-cover transform transition duration-500 ease-in-out group-hover:scale-110"
          src={currentSrc}
          alt={product.title}
          onMouseOver={() => product.images.dark && setCurrentSrc(product.images.dark)}
          onMouseOut={() => setCurrentSrc(product.images.light)}
        />
        {tag && (
          <div className="absolute top-2 right-2 bg-white text-brown px-2 py-1 text-sm uppercase tracking-wide">
            {tag}
          </div>
        )}
      </div>
      <div className="mt-3 mb-4  space-y-4">
        <h3 className="text-gray-900 dark:text-white line-clamp-2">
          {product.title}
        </h3>
        <span className="text-gray-900 dark:text-white ">
          ${price.toLocaleString()}
        </span>
      </div>
    </div>
    </Link>
   
  );
};

export default ProductCard;
